import DashboardProfileCorrectionModal from "./DashboardProfileCorrectionModal";

export default DashboardProfileCorrectionModal;